var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1,5.25v10a1,1,0,0,0,1,1H14a1,1,0,0,0,1-1v-10Zm1-3a2,2,0,0,0-2,2v11a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2v-11a2,2,0,0,0-2-2Z",
    transform: "translate(0 -1.25)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M7.25,0a.5.5,0,0,1,.5.5V1a.5.5,0,0,1-1,0V.5A.5.5,0,0,1,7.25,0Zm9,0a.5.5,0,0,1,.5.5V1a.5.5,0,0,1-1,0V.5A.5.5,0,0,1,16.25,0Z",
    transform: "translate(-3.75)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5e8bac95023bf220bd0462d07f597c2f.svg";
export { ForwardRef as ReactComponent };